<template>
  <modal name="margin-modal" :height="720" :clickToClose="false" @before-open="beforeOpen">
    <div class="kt-portlet">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">Margin Instruction</h3>
        </div>
      </div>
      <div>
        <div class="kt-portlet__body">
          <div class="row">
            <div class="col-lg-6" v-for="marginType in marginTypes" :key="marginType.id">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <img
                  width="40%"
                  :src="marginType.sample"
                  alt
                />

                <div class="mt-3">
                  <label class="d-flex justify-content-center align-items-center">
                    <input type="radio" :value="marginType.id" v-model="margin.marginTypeId" />
                    <h6 class="ml-2">
                      {{ marginType.title }}
                      <span class="ml-1">(${{ marginType.price }})</span>
                    </h6>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="border"></div>
        <div class="kt-portlet__body">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group row">
                <label class="col-lg-2 col-form-label">Top</label>
                <div class="col-lg-10">
                  <input
                    type="number"
                    v-model="margin.marginProperty.top"
                    :disabled="isInputDisabled"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group row">
                <label class="col-lg-3 col-form-label">Bottom</label>
                <div class="col-lg-9">
                  <input
                    type="number"
                    v-model="margin.marginProperty.bottom"
                    :disabled="isInputDisabled || isInputDisabledForBLR"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group row">
                <label class="col-lg-2 col-form-label">Left</label>
                <div class="col-lg-10">
                  <input
                    type="number"
                    v-model="margin.marginProperty.left"
                    :disabled="isInputDisabled || isInputDisabledForBLR"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group row">
                <label class="col-lg-3 col-form-label">Right</label>
                <div class="col-lg-9">
                  <input
                    type="number"
                    v-model="margin.marginProperty.right"
                    :disabled="isInputDisabled || isInputDisabledForBLR"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <div class="kt-form__actions kt-form__actions--right">
          <div class="row">
            <div class="col kt-align-left">
              <button type="button" class="btn btn-success" @click.prevent="reset">Reset</button>
            </div>
            <div class="col kt-align-right">
              <button type="button" class="btn btn-secondary" @click.prevent="close">Close</button>
              <button type="button" class="btn btn-brand ml-2" @click.prevent="save">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      isInputDisabled: false,
      isInputDisabledForBLR: false,
      margin: {
        marginTypeId: null,
        marginProperty: {
          top: '',
          bottom: '',
          left: '',
          right: '',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      marginTypes: 'service/marginTypes',
      orderAddOns: 'order/addOns',
    }),
  },
  watch: {
    'margin.marginTypeId': function (newValue) {
      let type;

      this.marginTypes.map((marginType) => {
        if (marginType.id == newValue) {
          type = marginType.type;
        }
      });

      if (type == 'auto') {
        this.isInputDisabled = true;
        this.margin.marginProperty.top = '';
        this.margin.marginProperty.bottom = '';
        this.margin.marginProperty.left = '';
        this.margin.marginProperty.right = '';
        return;
      }

      if (type == 'square') {
        this.isInputDisabledForBLR = true;
        this.isInputDisabled = false;
        let top = this.margin.marginProperty.top;
        this.margin.marginProperty.bottom = top;
        this.margin.marginProperty.left = top;
        this.margin.marginProperty.right = top;
        return;
      }

      this.isInputDisabled = false;
      this.isInputDisabledForBLR = false;

      return newValue;
    },
    'margin.marginProperty.top': function (newValue) {
      let type;

      this.marginTypes.map((marginType) => {
        if (marginType.id == this.margin.marginTypeId) {
          type = marginType.type;
        }
      });

      if (type == 'square') {
        this.margin.marginProperty.bottom = newValue;
        this.margin.marginProperty.left = newValue;
        this.margin.marginProperty.right = newValue;
      }

      return newValue;
    },
  },
  methods: {
    save() {
      let type;

      this.marginTypes.map((marginType) => {
        if (marginType.id == this.margin.marginTypeId) {
          type = marginType.type;
        }
      });

      if (type == 'custom' || type == 'square') {
        if (
          this.margin.marginProperty.top == '' ||
          this.margin.marginProperty.bottom == '' ||
          this.margin.marginProperty.left == '' ||
          this.margin.marginProperty.right == ''
        ) {
          return;
        }
      }

      this.$emit('margin', this.margin);

      this.$modal.hide('margin-modal');
    },
    close() {
      this.$emit('close');

      this.$modal.hide('margin-modal');
    },
    reset() {
      this.clear();
    },
    beforeOpen() {
      if (this.orderAddOns.margin) {
        this.margin.marginTypeId = this.orderAddOns.margin.marginTypeId;
        this.margin.marginProperty.top = this.orderAddOns.margin.marginProperty.top;
        this.margin.marginProperty.bottom = this.orderAddOns.margin.marginProperty.bottom;
        this.margin.marginProperty.left = this.orderAddOns.margin.marginProperty.left;
        this.margin.marginProperty.right = this.orderAddOns.margin.marginProperty.right;
      } else {
        this.clear();
      }
    },
    clear() {
      this.margin.marginTypeId = null;
      this.margin.marginProperty.top = '';
      this.margin.marginProperty.bottom = '';
      this.margin.marginProperty.left = '';
      this.margin.marginProperty.right = '';
    },
  },
};
</script>

<style>
.h-84 {
  height: 21rem !important;
}
.overflow-y-auto {
  overflow-y: auto;
}
input[type='radio'] {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  outline: none !important;
  -webkit-appearance: none;
}
input[type='radio']::before {
  position: relative;
  top: -1px;
  left: -1px;
  display: block;
  content: '';
  background: white;
  border: 1px solid rgba(128, 128, 128, 0.4);
  border-radius: 100%;
  box-shadow: inset 0 0.1em 1px -0.1em rgba(0, 0, 0, 0.3);
  width: 22px;
  height: 22px;
}
input[type='radio']:active::before {
  box-shadow: inset 0 0.1em 1px -0.1em rgba(0, 0, 0, 0.3),
    inset 0 0 2px 3px rgba(0, 0, 0, 0.1);
}
input[type='radio']:focus::before {
  box-shadow: inset 0 0.1em 1px -0.1em rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(30, 144, 255, 0.5);
}
input[type='radio']:checked::before {
  background: #a5d3ff;
  border-color: dodgerblue;
}
input[type='radio']:disabled::before {
  cursor: not-allowed;
  background-color: #eaeaea;
  border-color: rgba(128, 128, 128, 0.2);
}
input[type='radio']::after {
  position: relative;
  top: -17px;
  left: 15px;
  display: block;
  content: '';
  background: dodgerblue;
  border-radius: 100%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  width: 0;
  height: 0;
}
input[type='radio']:checked::after {
  -webkit-transition: all ease-in-out 100ms 0;
  transition: all ease-in-out 100ms 0;
  top: -18px;
  left: 4px;
  width: 12px;
  height: 12px;
}
input[type='radio']:disabled::after {
  background: #cccccc;
}
</style>
